import Title from 'antd/es/typography/Title';
import React from 'react'
import { FormSelect } from 'react-bootstrap'

interface IOption {
    value: string;
    label: string;
}

interface ISelectComp {
    title?: string;
    options: Array<IOption>;
    onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    className?: string;
    name: string;
    value?: string | number;
    [key: string]: any;
}

const SelectComp: React.FC<ISelectComp> = ({
    title,
    options = [],
    onChange = () => { },
    className,
    name,
    value,
    ...rest
}) => {
    return (
        <div>
            {
                title && <Title level={5}>{title}</Title>
            }
            <FormSelect
                name={name}
                onChange={onChange}
                className={className}
                value={value}
                {...rest}
            >
                {
                    options.map(option =>
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    )
                }
            </FormSelect>
        </div>
    )
}

export default SelectComp